"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definable = void 0;
const definables_1 = require("./definables");
const getRandomDefinableID_1 = require("./getRandomDefinableID");
class Definable {
    constructor(id) {
        this._id = id !== null && id !== void 0 ? id : (0, getRandomDefinableID_1.getRandomDefinableID)();
        if (definables_1.definables.has(this.constructor.name) === false) {
            definables_1.definables.set(this.constructor.name, new Map());
        }
        const list = definables_1.definables.get(this.constructor.name);
        if (list) {
            if (list.has(this._id)) {
                throw new Error(`${this.constructor.name} "${this._id}" already exists.`);
            }
            list.set(this._id, this);
        }
        this._createOrder = Definable._createOrderCounter;
        Definable._createOrderCounter++;
    }
    get id() {
        return this._id;
    }
    getReference() {
        return {
            className: this.constructor.name,
            id: this._id,
        };
    }
    remove() {
        const definablesMap = definables_1.definables.get(this.constructor.name);
        if (typeof definablesMap === "undefined") {
            throw new Error(`An attempt was made to remove ${this.constructor.name} "${this._id}" with no existing definables map.`);
        }
        definablesMap.delete(this._id);
    }
    getAccessorErrorMessage(property) {
        return `Could not access ${this.constructor.name} "${this._id}" ${property}.`;
    }
}
exports.Definable = Definable;
Definable._createOrderCounter = 0;
